import type { FC, ReactNode } from 'react'

import { cn } from '@/lib/utils'
import { SectionHeading } from '@/components/generals/section-heading'
import { PROCESS } from '@/constants/services'

interface ProcessSectionProps {
    className?: string
}

export const ProcessSection: FC<ProcessSectionProps> = ({ className }): ReactNode => {
    return (
        <section id='process' aria-labelledby='process-title' className={cn('py-24 lg:py-32', className)}>
            <div className='mx-auto max-w-7xl px-5 sm:px-8'>
                <SectionHeading
                    id='process-title'
                    eyebrow="How it works"
                    title={<>From the first call to the <em className='text-primary'>final farewell</em></>}
                    description="A clear, unhurried process, with one person you can call at every step."
                    align='center'
                />

                <div className='relative mt-16 lg:mt-20'>
                    <span aria-hidden='true' className='absolute left-6 top-6 h-[calc(100%-3rem)] w-px bg-gold/30 lg:left-[10%] lg:right-[10%] lg:h-px lg:w-auto' />

                    <ol className='relative grid gap-10 lg:grid-cols-5 lg:gap-8'>
                        {PROCESS.map((step, index) => (
                            <li key={step.title} className='relative flex gap-6 lg:flex-col lg:items-center lg:gap-0 lg:text-center'>
                                <span className='relative z-10 flex size-12 shrink-0 items-center justify-center rounded-full border border-gold/40 bg-background font-heading text-2xl text-primary'>
                                    {index + 1}
                                </span>

                                <div className='lg:mt-6'>
                                    <h3 className='text-2xl leading-tight text-foreground'>
                                        {step.title}
                                    </h3>

                                    <p className='mt-2 text-[0.95rem] leading-relaxed text-muted-foreground'>
                                        {step.description}
                                    </p>
                                </div>
                            </li>
                        ))}
                    </ol>
                </div>
            </div>
        </section>
    )
}
